/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import { BulkActions } from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const bulkItemsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, BulkActions.receiveBulkItems))
);

export const deleteItemEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, BulkActions.deletedBulkItems))
);

export const uploadItemsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_UPLOAD && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, BulkActions.uploadedBulkItems))
);

export const bulkBatchEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_BATCH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, BulkActions.receiveBulkBatch))
);

export const bulkUpdateEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, BulkActions.updatedBulkItems))
);

export const bulkPostEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_POST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, BulkActions.postedBulkItems))
);

export const bulkHintsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_HINTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, BulkActions.receiveBulkHints))
);

export const bulkResultsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_RESULTS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, BulkActions.receiveBulkResults))
);

export const bulkStatusEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.BULK_STATUS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, BulkActions.receiveBulkStatus))
);
